import {
  REQUEST_POPUP_LIST,
  REQUEST_POPUP,
} from './mutation-types'

export default {
  [REQUEST_POPUP_LIST](state, receivedData) {
    state.popupList = receivedData.content
    state.popupListCount = receivedData.totalElements
  },
  [REQUEST_POPUP](state, receivedData) {
    state.popup = receivedData
  },
}